import * as React from "react";
import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
} from "@fluentui/react-components";
import PropTypes from "prop-types";

export const FluentDialog2 = ({ open, setOpen, children }) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{children[0]}</DialogTitle>
          <DialogContent>{children[1]}</DialogContent>
          <DialogActions position="start">{children[2]}</DialogActions>
          <DialogActions position="end">{children[3]}</DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

FluentDialog2.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  children: PropTypes.array,
};
